import Header from '@pixum/header';
import { TEXT_VARIANT } from '@pixum/text';
import type { DeviceOrientedComponentProps } from '../../types';
import type { FaqNode } from 'data-layer';
import { FaqItemList } from './partials';
import './styles.css';

export interface FaqCollectionProps extends DeviceOrientedComponentProps {
  faq: FaqNode;
  articleTitle?: string;
  articleInternalName?: string;
}

/**
 * FaqCollection Component (Server Component)
 *
 * Renders a collection of FAQ items with schema.org structured data.
 * The interactive collapse functionality is delegated to client components
 * (FaqItemList and FaqItem) to reduce client-side bundle size.
 *
 * Features:
 * - Server-rendered FAQ structure
 * - Schema.org FAQPage structured data (embedded in FaqNode)
 * - Responsive design for desktop and mobile
 */
export function FaqCollection(props: FaqCollectionProps) {
  const { faq, articleTitle, articleInternalName, device } = props;
  const { items, schemaOrg } = faq;

  return (
    <article className="faq" data-faq="faq-module" data-testid="faq-container">
      {articleTitle && (
        <Header headlineText={articleTitle} headlineVariant={TEXT_VARIANT.TITLE_2} level={2} textAlignment="left" />
      )}
      <FaqItemList items={items} articleInternalName={articleInternalName} device={device} />
      {schemaOrg && (
        <script
          id={articleTitle}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
        />
      )}
    </article>
  );
}
